import { IconButton } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import cx from 'classnames';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import MenuIcon from '@material-ui/icons/Menu';
import { T } from 'components/common/text';
import CustomSpan from 'components/common/text/CustomSpan';
import LinkIcon from '@material-ui/icons/Link';

interface AppItemProps {
  product: object | any;
  whoCanUse: string;
  usable: boolean;
  onClickAppModal?: (releaseNote: string) => void;
  onOpenBrowser?: (url: string) => void;
}

function AppItemCard({ product, whoCanUse, usable, onClickAppModal, onOpenBrowser }: AppItemProps) {
  const {
    iconUrl = '',
    releaseNote = '',
    isRelease = 0,
    productName = '',
    productSubName = '',
    description = '',
    softwareUrl = '',
    projectCode = '',
  } = product;

  return (
    <StyledAppItemCard data-component-name="AppItemCard">
      <div
        className={cx('appItemCard__wrapper', {
          released: !!isRelease && !!usable,
          unreleased: !isRelease || !usable,
        })}
      >
        <div className="appItemCard__container">
          <div className="appItemCard__card_icon_wrapper">
            <div className="appItemCard__card_icon_box">
              <img className="appItemCard__card_icon" src={iconUrl} />
            </div>
            <div className="appItemCard__release_icon_box">
              <IconButton
                disabled={!isRelease || !usable || releaseNote.length === 0}
                aria-label="release_note"
                className="appItemCard__release_icon"
                onClick={() => !!onClickAppModal && onClickAppModal(releaseNote)}
              >
                <MenuIcon style={{ color: '#cdcdd3', padding: 0, width: 24, height: 24 }} />
              </IconButton>
            </div>
          </div>
          <div className="appItemCard__contents_wrapper">
            <div className="appItemCard__card_title_box">
              <CustomSpan fontSize={26} fontWeight={600} fontColor="#222">
                {productName}
              </CustomSpan>
              <CustomSpan fontSize={12} fontWeight={400} fontColor="#888">
                {productSubName}
              </CustomSpan>
            </div>
            <div className="appItemCard__description">
              <CustomSpan fontSize={12} fontWeight={400} fontColor="#888">
                {description}
              </CustomSpan>
            </div>
          </div>
        </div>
        <div className="appItemCard__download_box">
          <div className="appItemCard__classify">
            <CustomSpan fontSize={14} fontWeight={600} fontColor="#222">
              <T>{whoCanUse}</T>
            </CustomSpan>
          </div>
          {!!onOpenBrowser ? (
            <IconButton
              disabled={!isRelease || !usable}
              aria-label="download"
              className="appItemCard__download_icon"
              onClick={() => {
                onOpenBrowser(softwareUrl);
              }}
            >
              <LinkIcon />
            </IconButton>
          ) : (
            <IconButton
              disabled={!isRelease || !usable}
              aria-label="download"
              className="appItemCard__download_icon"
              href={softwareUrl}
            >
              <SaveAltIcon />
            </IconButton>
          )}
        </div>
      </div>
    </StyledAppItemCard>
  );
}

const StyledAppItemCard = styled.div<{}>`
  cursor: default;
  .appItemCard__wrapper {
    width: 286px;
    height: 286px;
    border-radius: 10px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    justify-content: space-between;
    &.released {
      border: 1px solid #e1e1e7;
      &:hover {
        border: 1px solid #00bee2;
        background: rgba(204, 237, 249, 0.15);
        box-shadow: 0px 20px 40px 0px rgba(0, 83, 99, 0.15);
      }
    }

    &.unreleased {
      filter: saturate(0);
      background-color: #f9f9fb;
      p {
        color: #cdcdd3 !important;
      }
    }
    .appItemCard__container {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      .appItemCard__card_icon_wrapper {
        display: flex;
        justify-content: space-between;
        height: 50px;
        .appItemCard__card_icon_box {
          .appItemCard__card_icon {
            height: 40px;
            width: auto;
          }
        }
        .appItemCard__release_icon_box {
          display: flex;
          align-items: flex-start;
        }
        .appItemCard__release_icon {
          padding: 1px;
          border-radius: 5px;
        }
      }

      .appItemCard__contents_wrapper {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        .appItemCard__card_title_box {
          display: flex;
          column-gap: 10px;
          align-items: center;
        }
      }
    }

    .appItemCard__download_box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .appItemCard__classify {
        padding: 5px 12px;
        border: 1px solid #e1e1e7;
        border-radius: 20px;
      }
      .appItemCard__download_icon {
        border-radius: 10px;
        background-color: #25256f;
        padding: 8px;
        width: 40px;
        height: 40px;
        color: #fff;
        &.Mui-disabled {
          background-color: #ccccd4;
        }
      }
    }
  }
`;

export default React.memo(AppItemCard);
